<script>
    import { createEventDispatcher } from "svelte";
    import Carreras from "./carreras.svelte";
    import Aviso from "../../componentes/Aviso.svelte";

    const dispatch = createEventDispatcher();

    let carreras = [];
    let dni = "";
    let fec_nac = "";
    let email = "";
    let email2 = "";
    let emailDisplayMensaje = "none";
    let emailDisplayModal = "none";
    let emailMensaje = "";
    let email_original = "";
    let displayMensajeFinal = "none";
    let displayModalCarreras = "none";
    let displayContraseniasNoIguales = "none";
    let mensajeContraseniasNoIguales = "";
    let token = "";

    let tip_doc = "DN";

    const tipDoc = [
        {id: "DN", desc: "Documento Nacional de Identidad"},
        {id: "LE", desc: "Libreta de Enrolamiento"},
        {id: "LC", desc: "Libreta Cívica"},
        {id: "PA", desc: "Pasaporte"},
        {id: "CI", desc: "Cédula de Identidad"},
        {id: "CF", desc: "Cédula de Federal"},
    ]

    const aviso = {
        titulo: "",
        display: "none",
        mensajes: [],
        mensaje(m) {
            aviso.mensajes.push(m);
        },
        mostrar(t = "Aviso") {
            if (aviso.mensajes.length > 0) {
                aviso.titulo = t;
                aviso.display = "block";
            }
        },
        reset() {
            aviso.mensajes = [];
            aviso.display = "none";
        },
    };

    function agergar_carreras(event) {
        let z = [];
        let x = event.detail;
        let existe = 0;
        carreras.map((c) => {
            if (c.cod_uni == x.cod_uni && c.cod_car == x.cod_car) {
                c.anio = x.anio;
                existe++;
                z.push({ ...c });
            } else {
                z.push({ ...c });
            }
        });
        // if(carreras.length>0){
        //     console.log('carreras:', carreras);
        //     console.log('x:',x);
        //     return;
        // }
        //console.log("existe:", existe);

        if (existe == 0) {
            z.push(x);
        }
        carreras = [...z];

        displayModalCarreras = "none";
    }

    function quitar(x) {
        //console.log("QUITAR:", x);
        let z = [];
        carreras.map((c) => {
            if (c.cod_uni != x.cod_uni && c.cod_car != x.cod_car)
                z.push({ ...c });
        });
        carreras = [...z];
    }

    async function continuar() {
        /*
        console.log("dni:", dni);
        console.log("fec_nac", fec_nac);
        console.log("carreras:", carreras);
        */
        aviso.reset();
        if (dni.trim().length == 0) aviso.mensaje("Debe ingresar el DNI");
        if (fec_nac == "")
            aviso.mensaje("Debe ingresar la fecha de nacimiento");
        if (carreras.length == 0)
            aviso.mensaje("Debe ingresar las carreras de las que egresó");

        if (aviso.mensajes.length > 0) {
            aviso.mostrar("Atención ! ! !");
            return;
        }

        const body = new FormData();
        body.append("accion", "crearContrasenia");
        body.append("dni", tip_doc + ' ' + dni.trim());
        body.append("fec_nac", fec_nac);
        body.append("email", email);
        let ccc = "";
        carreras.map((c) => {
            ccc += c.cod_uni + ":" + c.cod_car + ":" + c.anio + ";";
        });
        ccc = ccc.substr(0, ccc.length - 1);
        body.append("carreras", ccc);

        const rst = await fetch("./api/usuarios.php", {
            method: "POST",
            body,
        });

        if (rst.ok) {
            let json = await rst.json();
            if (json.error) {
                aviso.mensaje(json.mensaje);
                aviso.mostrar("Atención ! ! !");
                return;
            } else {
                /* aviso de te hemos enviado un mail para continuar .....*/
                email_original = json.email_original;
                token = json.token;
                emailDisplayModal = "block";
                //alert(json.mensaje);
            }
        }
    }

    function confirma1() {
        email = email_original;
        emailDisplayModal = "none";
        displayMensajeFinal = "block";
    }

    async function confirma2() {
        aviso.reset();
        if (email.trim() != email2.trim()) {
            mensajeContraseniasNoIguales =
                "Los eMails ingresados no coinciden o no son válidos ! ! !";
            displayContraseniasNoIguales = "block";
            return;
        }

        if (email.trim().length == 0 || email.trim().includes("@") < 1) {
            mensajeContraseniasNoIguales =
                "Los eMails ingresados no coinciden o no son válidos ! ! !";
            displayContraseniasNoIguales = "block";
            return;
        }

        const body = new FormData();
        body.append("accion", "actualiza_email");
        body.append("dni", dni);
        body.append("tip_doc", tip_doc);
        body.append("email", email);
        body.append("token", token);

        const rst = await fetch("./api/usuarios.php", {
            method: "POST",
            body,
        });

        if (rst.ok) {
            let json = await rst.json();
            if (json.error) {
                mensajeContraseniasNoIguales = json.mensaje;
                displayContraseniasNoIguales = "block";
                return;
            } else {
                emailDisplayModal = "none";
                displayMensajeFinal = "block";
            }
        }
    }
</script>

<div class="w3-container">
    <div class="w3-padding w3-border w3-round">
        {#if displayMensajeFinal == "block"}
            <h3>Actualización de eMail correcta ! ! !</h3>
            <div class="w3-section">
                Ahora pudes ingresar por la opción <b
                    >Olvidaste tu contraseña o deseas crear una nueva</b
                > <br />
                para actualizar tu contraseña utilizando el eMail:
                <b>{email}</b>
                <br /> <br />
                <button
                    class="w3-btn w3-blue w3-round"
                    on:click={() => {
                        dispatch("cancelar");
                    }}>Continuar</button
                >
            </div>
        {:else}
            <h4>Habilitar mi cuenta.</h4>
            <div class="w3-section w3-text-red w3-large">
                Para habilitar tu cuenta vamos a verificar tu identidad.<br />
                Esta habilitación te permitirá Crear o modificar tu contraseña.<br
                />
                Por favor ingresa la siguiente información.
            </div>
            <div class="w3-section">
                <label for="clave">Tipo de Documento:</label>
                <select class="w3-input w3-light-grey" bind:value={tip_doc}>
                    {#each tipDoc as tido}
                        <option value={tido.id}>{tido.desc}</option>
                    {/each}
                </select>
            </div>
            <div class="w3-section">
                <label for="clave">Número de Documento:</label>
                <input
                    type="text"
                    maxlength="8"
                    class="w3-input w3-round w3-light-grey"
                    bind:value={dni}
                />
            </div>
            <div class="w3-section">
                <label>Fecha de nacimiento:</label>
                <input
                    type="date"
                    class="w3-input w3-round w3-light-grey"
                    bind:value={fec_nac}
                />
            </div>

            <div class="w3-section">
                <label
                    >Carreras de las que egresaste en la Universidad Católica de
                    Córdoba:</label
                >
                <div class="w3-responsive">
                    <div class="w3-section">
                        <button
                            class="w3-btn w3-blue w3-round"
                            on:click={() => (displayModalCarreras = "block")}
                            >Agregar Carrera</button
                        >
                    </div>
                    {#if carreras.length > 0}
                        <table class="w3-table-all w3-hoverable">
                            <thead>
                                <tr>
                                    <td>Carrera</td>
                                    <td style="width: 150px">Año de egreso</td>
                                    <td style="width: 100px" />
                                </tr>
                            </thead>
                            <tbody>
                                {#each carreras as c}
                                    <tr>
                                        <td>{c.nom_car}</td>
                                        <td style="text-align:center"
                                            >{c.anio}</td
                                        >
                                        <td style="text-align:center">
                                            <button
                                                style="height:20px; border:none; cursor:pointer; background-color: red; color:white; font-size: 9px;"
                                                on:click={() => quitar(c)}
                                                >Quitar</button
                                            >
                                        </td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    {/if}
                </div>
            </div>
            <div class="w3-section">
                <button class="w3-btn w3-blue w3-round" on:click={continuar}
                    >Continuar</button
                >
                <button
                    class="w3-btn w3-red w3-round w3-right"
                    on:click={() => dispatch("cancelar")}>Cancelar</button
                >
            </div>
        {/if}
    </div>
</div>

<Carreras
    display={displayModalCarreras}
    on:agregar={agergar_carreras}
    on:cerrar={() => (displayModalCarreras = "none")}
/>

<Aviso param={aviso} on:cerrar={() => aviso.reset()} />

<div class="w3-modal" style="display:{emailDisplayModal}">
    <div class="w3-modal-content w3-round w3-animatetop w3-white">
        <div class="w3-padding">
            <h3>Actualización de eMail</h3>
            <div class="w3-section w3-large w3-text-green">
                Hemos logrado verificar tu identidad satisfactoriamente. <br />
                Ahora te pedimos que confirmes o modifiques tu eMail para poder contactarte.
            </div>
            <div class="w3-section">
                <div>
                    El siguiente eMail es el que estamos utilizando actualmente
                    para contactarte.
                </div>
                <input
                    type="text"
                    readonly
                    class="w3-input w3-round w3-light-grey"
                    bind:value={email_original}
                />
                <br />
                <button class="w3-green w3-round w3-btn" on:click={confirma1}
                    >Confirmar eMail actual</button
                >
            </div>
            <div class="w3-section">
                <div>
                    Aquí puedes modificar tu eMail, para ello deberás ingresarlo
                    2 veces.
                </div>

                <input
                    type="email"
                    class="w3-input w3-round w3-light-grey"
                    bind:value={email}
                    placeholder="Ingresa el nuevo eMail..."
                    on:focus={() => (displayContraseniasNoIguales = "none")}
                />
                <br />

                <input
                    type="email"
                    class="w3-input w3-round w3-light-grey"
                    bind:value={email2}
                    placeholder="Repite el nuevo eMail..."
                    on:focus={() => (displayContraseniasNoIguales = "none")}
                />
                <div
                    class="w3-section"
                    style="display:{displayContraseniasNoIguales}"
                >
                    <div
                        class="w3-padding w3-yellow w3-text-red w3-round w3-center"
                    >
                        {mensajeContraseniasNoIguales}
                    </div>
                </div>
                <br />
                <button class="w3-btn w3-green w3-round" on:click={confirma2}
                    >Confirmar nuevo eMail</button
                >
            </div>
            <div class="w3-section">
                <button
                    class="w3-block w3-btn w3-red w3-round"
                    on:click={() => {
                        emailDisplayModal = "none";
                        email_original = "";
                        email = "";
                        email2 = "";
                    }}>Cancelar</button
                >
            </div>
        </div>
    </div>
</div>
